export const REALDB_CONSTANT = {
  Sellersdata: "/premiere_2024_nesco_h7_june/Sellersdata",
  SellerBaseData: "/premiere_2024_nesco_h7_june/SellerBaseData",
};
